<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{title}}</h3>
        </div>
        <div v-if="layer==1" class="col-3">
        <span>          
          <h3 v-if="location=='TTN'">Tân Thuận</h3>
          <h3 v-if="location=='NTMK'">Nguyễn Thị Minh Khai</h3>
          <h3 v-if="location=='DBP'">Điện Biên Phủ</h3>
        </span>
        </div>
        <div v-if="layer==1" class="col-4">
          <p class="mb-0">
          Bắt Đầu :  {{beginDate | moment("DD/MM/YYYY HH:mm")}}
          </p>
          <p class="mb-0">
          Kết Thúc: {{endDate | moment("DD/MM/YYYY HH:mm")}}
          </p>
        </div>
        <div class="col text-right">
          <base-button type="primary" v-if="checknhanca" @click="nhanca()" class="btn btn-sm btn-primary">Nhận Ca</base-button>
          <base-button type="primary" v-if="checkgiaoca" @click="giaoca()" class="btn btn-sm btn-primary">Giao Ca</base-button>
          <base-button type="warning" v-if="checkhuyca" @click="huynhanca()" class="btn btn-sm btn-primary">Hủy Nhận Ca</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="proctors">
        <template slot="columns">
          <th>Họ Tên</th>
          <th>Nhận Ca</th>
          <th>Giao Ca</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row"  class="p-1">
            {{row.name}}
          </th>
          <td class="p-1">
            {{formattime(row.beginDate)}}
          </td>
          <td class="p-1">
            {{formattime(row.endDate)}}
          </td>
          <td class="text-right p-1"  v-if="layer==3">
            <base-button type="primary" size="sm" v-if="checkdanhgia" @click="editMark(row)">
              Đánh Giá
            </base-button>
            <modal :show.sync="modals.modal0">
                  <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">{{proctor.name}} Total {{Number(score).toFixed(2)}}</h5>
                  </template>
                  <div>
                    <template v-for="(canon,index) in canons" >
                    {{canon.name}} : {{Number(canon.percent * canon.score / 100).toFixed(2)}}
                    <base-slider v-model="canon.percent" :range="{min: 0, max: 100}" :options="{start: 0}" :key="index">
                    </base-slider>
                    </template>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal0 = false">Close</base-button>
                    <base-button type="primary" @click="updateMark" >Lưu</base-button>
                  </template>
                </modal>

          </td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'page-visits-table',
    props:{
      title: {
        type: String
      },
      layer: {
        type: [String, Number]
      },
      proctors: {
        type: Array,
        
      },
      shiftDate: {
        type: String
      },
      shiftID: {
        type: String
      },
      endDate: {
        type: Date
      },
      beginDate:{
        type: Date
      }
    },
    data() {
      return {
          modals :{
            modal0: false
          },
          canons: {
            type: Array
          },
          proctor: {},
          result: {}
        }
    },
    computed: {
      score() {
        let total = 0
        for (var i =0,len =this.canons.length;i<len;i++){
          total += this.canons[i].score*this.canons[i].percent/100    
        }
        return total
      },
      checknhanca() {
        let difdate = this.$moment(this.shiftDate).diff(new Date(),'minutes')
        if(this.layer==3 && this.$store.state.user.permission <5)
        {
          return false
        }
        if(this.proctors){
          for (let i=0;i<this.proctors.length;i++)
          {
            if(this.proctors[i].userid === this.$store.state.user._id) {
              return false
            }
          }
        }
        if(difdate <= 120 && difdate >= -180) {
          return true
        }
        return false
      },
      checkgiaoca() {
        if(this.proctors){
          let obj = this.proctors.filter(proctor => { return proctor.userid === this.$store.state.user._id})
          if (obj.length ===0) {
            return false
          }
          let difdate = this.$moment(this.endDate).diff(new Date(),'minutes')
          if(obj.endDate) {
            return false
          }
          if(difdate <= 60 && difdate >= -60) {
            return true
          }
          return false
          }
        else {
          return false
        }
        
      },
      checkhuyca() {
        if(this.proctors){
          let obj = this.proctors.filter(proctor => { return proctor.userid === this.$store.state.user._id})
          if (obj.length ===0) {
            return false
          }

        }
        else {
          return false
        }
        let difdate = this.$moment(this.shiftDate).diff(new Date(),'minutes')
        if(difdate <= 120 && difdate >= -120) {
          return true
        }
        return false
      },
      checkdanhgia() {
        return this.$store.getters.is_admin
      },
      location() {
        return this.$store.getters.curlocation
      }
    },
    methods: {
      async getCanon() {
        let res = await this.$http.get('/canon')
        this.canons = res.data
      },
      editMark(proctor) {
        this.proctor = proctor
        this.modals.modal0 = true
      },
      async updateMark() {
        let data = {shiftID: this.shiftID, shiftDate: this.shiftDate, proctor: this.proctor.name , proctorID : this.proctor.userid, username: 'AFV', score: this.score}
        await this.$http.post('/mark/add', data)
        this.modals.modal0 = false
      },
      async nhanca() {
        if (this.$store.getters.curlocation ==='TTN') {
          let data = {shiftid: this.shiftID, name: this.$store.state.user.username, userid:this.$store.state.user._id, layer:this.layer}
          await this.$http.post('/ttn/in', data)
        }
        else if (this.$store.getters.curlocation ==='NTMK') {
          let data = {shiftid: this.shiftID, name: this.$store.state.user.username, userid:this.$store.state.user._id, layer:this.layer}
          await this.$http.post('/ntmk/in', data)
        } else if (this.$store.getters.curlocation ==='DBP') {
          let data = {shiftid: this.shiftID, name: this.$store.state.user.username, userid:this.$store.state.user._id, layer:this.layer}
          await this.$http.post('/dbp/in', data)
        }
        let proctor = {beginDate: this.$moment().format(), name: this.$store.state.user.username, userid:this.$store.state.user._id, layer:this.layer}
        this.$emit('update-proctor',proctor)
      },
      async giaoca() {
        let data = {shiftid: this.shiftID, userid: this.$store.state.user._id}
        let obj = this.proctors.filter(proctor => { return proctor.userid===this.$store.state.user._id})[0]
        obj.endDate = this.$moment().format()
        this.$emit('update-proctor', obj)
        if(this.$store.getters.curlocation ==='TTN'){
          await this.$http.post('/ttn/out', data)
        }
        else if (this.$store.getters.curlocation ==='NTMK') {
          await this.$http.post('/ntmk/out', data)
        } else if (this.$store.getters.curlocation ==='DBP') {
          await this.$http.post('/dbp/out', data)
        }
        
      },
      async huynhanca() {
        let data = {shiftid: this.shiftID, userid: this.$store.state.user._id}
        if(this.$store.getters.curlocation ==='TTN'){
          await this.$http.post('/ttn/cancel', data)
        }
        else if (this.$store.getters.curlocation ==='NTMK') {
          await this.$http.post('/ntmk/cancel', data)
        } else if (this.$store.getters.curlocation ==='DBP') {
          await this.$http.post('/dbp/cancel', data)
        }
        this.$emit('cancel-proctor')
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
  

    },
    mounted() {
      this.getCanon()
    }
  }
</script>
<style>
</style>
